export default __webpack_public_path__ + "static/media/connect-dark.0b506c4a.webp";